import { Component } from '@angular/core';
import {
  Sparkles,
  ShoppingCart,
  FileText,
  Database,
  TrendingUp,
  Users,
  Shield,
  Zap,
  Recycle,
  BarChart3,
  CheckCircle2
} from 'lucide-angular';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  standalone: false

})
export class SubscriptionComponent {

  // Lucide icons
  readonly iconSparkles = Sparkles;
  readonly iconShoppingCart = ShoppingCart;
  readonly iconFileText = FileText;
  readonly iconDatabase = Database;
  readonly iconTrendingUp = TrendingUp;
  readonly iconUsers = Users;
  readonly iconShield = Shield;
  readonly iconZap = Zap;
  readonly iconRecycle = Recycle;
  readonly iconBarChart = BarChart3;
  readonly iconCheck = CheckCircle2;

  openMoreInfo(){
    window.open('https://ekowitryna.pl', '_blank', 'noopener');
  }

  openBuyNow(){
    window.open('https://ekowitryna.pl/produkt/ekowitryna-starter/', '_blank', 'noopener');
  }

}
